import { ShieldCheck, Sparkles, Clock4, BadgeCheck } from "lucide-react";
import { VALUES, PROCESS, BRAND } from "@/data/content";

const ICONS = [Sparkles, ShieldCheck, BadgeCheck, Clock4];

export const About = () => {
    return (
        <section
            id="hakkimizda"
            data-testid="about-section"
            className="py-24 sm:py-32 bg-white relative overflow-hidden"
        >
            {/* Subtle background pattern */}
            <div className="absolute inset-0 pointer-events-none opacity-50">
                <div className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full bg-[#E5EFFF] blur-3xl" />
            </div>

            <div className="onx-container relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                    {/* Left column */}
                    <div className="lg:col-span-5 lg:sticky lg:top-32">
                        <div className="onx-overline mb-4">Hakkımızda</div>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[0.95] text-[#0B1B2B]">
                            Temizliği bir <br />
                            <span className="text-[#0055FF]">
                                meslek olarak
                            </span>{" "}
                            yapıyoruz.
                        </h2>
                        <div className="mt-6 space-y-4 text-base sm:text-lg leading-relaxed text-[#4A6177]">
                            <p>
                                <strong className="text-[#0B1B2B]">
                                    ONX Care
                                </strong>
                                , Beşiktaş merkezli; konutlar, ofisler,
                                ticari işletmeler ve araçlar için profesyonel
                                temizlik çözümleri sunan bir hizmet
                                markasıdır.
                            </p>
                            <p>
                                Misyonumuz; eğitimli ekip, doğru ekipman ve
                                sertifikalı kimyasallarla hijyen standardını
                                yükseltirken, sizin için zaman ve huzur
                                kazandırmak. Tüm İstanbul'a haftanın 7 günü
                                hizmet veriyoruz.
                            </p>
                        </div>

                        <div className="mt-8 flex flex-col sm:flex-row gap-3">
                            <a
                                href={BRAND.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="about-cta-whatsapp"
                                className="onx-btn-primary"
                            >
                                WhatsApp'tan Yaz
                            </a>
                            <a
                                href="#iletisim"
                                data-testid="about-cta-contact"
                                className="onx-btn-secondary"
                            >
                                İletişim Bilgileri
                            </a>
                        </div>
                    </div>

                    {/* Right column - values */}
                    <div className="lg:col-span-7">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                            {VALUES.map((v, i) => {
                                const Icon = ICONS[i % ICONS.length];
                                return (
                                    <div
                                        key={v.title}
                                        data-testid={`value-card-${i}`}
                                        className="group relative p-6 sm:p-7 rounded-3xl bg-[#F4F8FB] border border-[#0055FF]/10 hover:border-[#0055FF]/30 hover:bg-white transition-all duration-500"
                                    >
                                        <div className="w-12 h-12 rounded-2xl bg-[#0055FF] flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                            <Icon
                                                className="w-5 h-5 text-white"
                                                strokeWidth={2.4}
                                            />
                                        </div>
                                        <h3 className="text-xl font-bold tracking-tight text-[#0B1B2B]">
                                            {v.title}
                                        </h3>
                                        <p className="mt-2 text-sm sm:text-base text-[#4A6177] leading-relaxed">
                                            {v.desc}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Process */}
                        <div className="mt-10 p-6 sm:p-8 rounded-3xl bg-[#0B1B2B] text-white relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-[#0055FF]/30 blur-3xl" />
                            <div className="relative">
                                <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#7AA5FF] mb-3">
                                    Nasıl Çalışıyoruz
                                </div>
                                <h3 className="text-2xl sm:text-3xl font-bold tracking-tight text-white">
                                    4 adımda kusursuz hizmet
                                </h3>
                                <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                                    {PROCESS.map((p) => (
                                        <div
                                            key={p.step}
                                            data-testid={`process-${p.step}`}
                                            className="flex items-start gap-4"
                                        >
                                            <span className="text-2xl font-black text-[#7AA5FF] leading-none mt-0.5">
                                                {p.step}
                                            </span>
                                            <div>
                                                <div className="text-base font-bold text-white">
                                                    {p.title}
                                                </div>
                                                <div className="mt-0.5 text-sm text-white/70 leading-relaxed">
                                                    {p.desc}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
